import React from "react";
import Swal from "sweetalert2";
import { useForm, Controller, } from "react-hook-form";

// Material-UI
import { Button, Container, Grid, Card, Typography, TextField } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import NavbarUser from "../components/NavbarUser";
import Background from "../components/BackgroundPattern";
import TitlePage from "../components/TitlePageUser";
import Footer from "../components/Footer";
// Data
import DataStatusPembayaran from "../data/DataStatusPembayaran";
import DataTagihanPembayaran from "../data/DataTagihanPembayaran";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  section: {
    margin: theme.spacing(2, 0),
  },
  table: {
    minWidth: 700,
  },
  unduh: {
    width: 50,
    padding: theme.spacing(1),
  },
  bgWhite: {
    backgroundColor: "white"
  },
  paper: {
    padding: theme.spacing(2)
  },
  input: {
    width: "-webkit-fill-available",
    margin: theme.spacing(1, 0),
    padding: theme.spacing(2),
    border: "1px solid rgb(133, 133, 133)",
    borderRadius: "5px"
  }
}));

const NominalPembayaran = ({ classes }) => {
  return (
    <section id="Nominal-pembayaran">
      <Container className={classes.section} maxWidth="md">
        <Card className={classes.section} elevation={3}>
          <Alert variant="filled" severity="info">
            <AlertTitle>{"Nominal Pembayaran"}</AlertTitle>
              <Typography variant="body2" gutterBottom>
                {"Pembayaran melalui DANA/OVO/GOPAY dengan Nomor 0812-1111-7691"}
              </Typography>
              <Typography variant="body2" gutterBottom>
                {"1. Pendaftaran    : Rp. 20.000"}
              </Typography>
              <Typography variant="body2"  gutterBottom>
                {"2. Materi Diklat  : Rp. 50.000"}
              </Typography>
              <Typography variant="body2"  gutterBottom>
                {"3. Pengukuhan     : Rp. 100.000"}
              </Typography>
          </Alert>
        </Card>
      </Container>
    </section>
  );
};

// Style Tabel
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);


// Tabel Status Pembayaran
const TabelStatusPembayaran = ({ classes }) => {
  const tabelStatusPembayaran = DataStatusPembayaran.map((data) => (
    <StyledTableRow key={data.id}>
      <StyledTableCell component="th" align="justify">
        {data.id}
      </StyledTableCell>
      <StyledTableCell align="justify">{data.jenisPembayaran}</StyledTableCell>
      <StyledTableCell align="justify">{data.bayar}</StyledTableCell>
      <StyledTableCell align="justify">{data.status}</StyledTableCell>
    </StyledTableRow>
  ));

  return (
    <Container className={classes.section} maxWidth="md">
      <TableContainer component={Paper} elevation={3}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="justify">{"No"}</StyledTableCell>
              <StyledTableCell align="justify">{"Jenis Pembayaran"}</StyledTableCell>
              <StyledTableCell align="justify">{"Sudah Bayar"}</StyledTableCell>
              <StyledTableCell align="justify">{"Status"}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tabelStatusPembayaran}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

// Tagihan Pembayaran
const TabelTagihanPembayaran = ({ classes }) => {
  const tabelTagihanPembayaran = DataTagihanPembayaran.map((data) => (
    <StyledTableRow key={data.id}>
      <StyledTableCell component="th" align="justify">
        {data.id}
      </StyledTableCell>
      <StyledTableCell align="justify">{data.jenisPembayaran}</StyledTableCell>
      <StyledTableCell align="justify">{data.tagihan}</StyledTableCell>
    </StyledTableRow>
  ));

  return (
    <Container className={classes.section} maxWidth="md">
      <TableContainer component={Paper} elevation={3}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="justify">{"No"}</StyledTableCell>
              <StyledTableCell align="justify">{"Jenis Pembayaran"}</StyledTableCell>
              <StyledTableCell align="justify">{"Nominal"}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{tabelTagihanPembayaran}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

const PembayaranBaru = ( {classes} ) => {
  const { handleSubmit, control, register } = useForm();
  const onSubmit = (data) => {
    console.log(data)
    if (data.pilihPembayaran === "Diklat" && data.nominalBayar === "50000") {
      return Swal.fire({
        icon: "success",
        title: "Pembayaran Diklat Berhasil",
        text: "Tagihan akan berubah setelah panitia konfirmasi pembayaran",
      });
    } else if (data.pilihPembayaran === "Pengukuhan" && data.nominalBayar === "100000") {
      return Swal.fire({
        icon: "success",
        title: "Pembayaran Pengukuhan Berhasil",
        text: "Tagihan akan berubah setelah panitia konfirmasi pembayaran",
      });
    } else {
      return Swal.fire({
        icon: "error",
        title: "Nominal Tagihan Kurang",
        text: "Silahkan masukkan seluruh nominal tagihan",
      });
    }
  };

  return (
    <section id="pembayaran-baru">
      <Container className={classes.section} maxWidth="md">
        <Paper elevation={5} className={classes.paper}>
            <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={12}>
                  <FormControl className={classes.bgWhite} variant="outlined" margin="normal" required fullWidth>
                    <InputLabel id="pilihPembayaran">{"Pilih Tagihan"}</InputLabel>
                    <Controller
                      as={
                        <Select
                          labelId="pilihPembayaran"
                          id="pilihPembayaran"
                          label="Pilih Materi"
                        >
                          <MenuItem value="">
                            <em>Pilih Tagihan</em>
                          </MenuItem>
                          <MenuItem value="Diklat">{"Diklat"}</MenuItem>
                          <MenuItem value="Pengukuhan">{"Pengukuhan"}</MenuItem>
                        </Select>
                      }
                      name="pilihPembayaran"
                      control={control}
                      defaultValue=""
                      required
                    />
                  </FormControl>
                  <TextField
                    id="nominalBayar"
                    name="nominalBayar"
                    inputRef={register({ required: true })}
                    label="Nominal Pembayaran"
                    type="number"
                    variant="outlined"
                    margin="normal"
                    placeholder="contoh : 50000 / 100000"
                    required
                    fullWidth
                  />
                  <input 
                    id="buktiBayar"
                    name="buktiBayar"
                    ref={register({ required: true })}
                    type="file"
                    accept="image/png, image/jpeg"
                    className={classes.input}
                  />
                  <Typography variant="caption" align="center" color="primary">
                    {"Unggah Bukti Pembayaran (ukuran maksimal 1MB)"}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    type="submit"
                    fullWidth
                  >
                    {"Unggah Bukti Bayar"}
                  </Button>
                </Grid>
                <Grid item xs={1} sm={2} md={4}></Grid>
              </Grid>
            </form>
        </Paper>
      </Container>
    </section>
  );
};


const UserPembayaran = () => {
  const classes = useStyles();
  return (
    <section id="status-pembayaran" className={classes.container}>
      <Background/>
      <NavbarUser />
      <Container style={{flex: "1"}}>
        <TitlePage text="Status Pembayaran" />
        <NominalPembayaran classes={classes} />
          <TabelStatusPembayaran classes={classes} />
        <TitlePage text="Tagihan Pembayaran" />
          <TabelTagihanPembayaran classes={classes} />
        <TitlePage text="Pembayaran Baru" />
          <PembayaranBaru classes={classes} />
      </Container>
      <Footer />
    </section>
  );
};

export default UserPembayaran;
